import { render, staticRenderFns } from "./PersonDetail.vue?vue&type=template&id=62fef3bf&scoped=true"
import script from "./PersonDetail.vue?vue&type=script&lang=js"
export * from "./PersonDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonDetail.vue?vue&type=style&index=0&id=62fef3bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fef3bf",
  null
  
)

export default component.exports